export default __webpack_public_path__ + "static/media/288.93ba4335.jpg";